import { AxiosError, type AxiosResponse } from 'axios';
import AxiosInstance from '../../helpers/axios-instance/axios-instance';
import { appConfig } from '../../helpers/app-config/app-config';
import type { Repository } from './scm-client.type';

const axiosInstance = AxiosInstance();
const baseURL = appConfig.VITE_APP_API_URL;

/**
 * Fetches a minimal list of repositories (id, name) scoped to a portfolio.
 *
 * @param {string} portfolioId - Portfolio ID to filter repositories by
 * @returns {Promise<Repository[]>} Array of minimal repositories
 */
async function getRepositoriesMinimal(portfolioId: string): Promise<Repository[]> {
  try {
    const url = baseURL + `/api/repositories/minimal/?portfolio_id=${portfolioId}`;
    const response: AxiosResponse = await axiosInstance.get(url);
    return response.data;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      return Promise.reject(error.response);
    }
    return Promise.reject(new Error('An unknown error occurred while fetching minimal repositories.'));
  }
}

export { getRepositoriesMinimal };
